import type { MouseEvent, ReactNode } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

const colors = {
    background: colorsPalettes.carbon[0],
    border: colorsPalettes.carbon[50],
    borderHover: colorsPalettes.carbon[100],
    icon: colorsPalettes.carbon[400],
};

interface TrackSectionEntityCardContainerProps {
    children: ReactNode;
    isInteractive?: boolean;
    onClick?: (e: MouseEvent<HTMLElement>) => void;
}

export const TrackSectionEntityCardContainer = ({
    children,
    isInteractive = true,
    onClick,
}: TrackSectionEntityCardContainerProps) => {
    return (
        <Flex
            data-automation="demand-analysis-homepage-entity-card"
            height="64px"
            flexDirection="row"
            alignItems="center"
            paddingY="12px"
            paddingX="16px"
            gap="16px"
            borderRadius="6px"
            border={`1px solid ${colors.border}`}
            background={colors.background}
            cursor={isInteractive ? "pointer" : "default"}
            transition="box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out"
            whenHover={
                isInteractive ? { boxShadow: "0px 3px 6px 0px #0E1E3E14", borderColor: colors.borderHover } : undefined
            }
            onClick={onClick}
        >
            {children}
        </Flex>
    );
};

const IconBox = () => {
    return (
        <Flex
            width="32px"
            height="32px"
            background={colors.background}
            borderRadius="6px"
            border={`1px solid ${colors.border}`}
            alignItems="center"
            justifyContent="center"
        >
            <SWReactIcons
                iconName="nav-keyword-group"
                size="xs"
                iconColor={colors.icon}
            />
        </Flex>
    );
};

interface TitleGroupProps {
    children: ReactNode;
    gap?: string;
}

const TitleGroup = ({ children, gap }: TitleGroupProps) => {
    return (
        <Flex
            flexDirection="column"
            alignItems="flex-start"
            flexGrow="1"
            gap={gap}
        >
            {children}
        </Flex>
    );
};

interface TrendGroupProps {
    children: ReactNode;
}

const TrendGroup = ({ children }: TrendGroupProps) => {
    return (
        <Flex
            alignItems="center"
            gap="16px"
        >
            {children}
        </Flex>
    );
};

TrackSectionEntityCardContainer.IconBox = IconBox;
TrackSectionEntityCardContainer.TitleGroup = TitleGroup;
TrackSectionEntityCardContainer.TrendGroup = TrendGroup;
